"use client";

import fixImageURI from "@/app/ec/product/fixImageURI";
import ProductImage from "@/app/ec/product/productImage";
import Modal from "@/components/design-system/modal";
import { useMemo, useState } from "react";
import style from "./productMedia.module.scss";

type MediaProps = {
  mediaPath: string | null;
  alt?: string;
  additionalImages?: Array<{
    s: string;
    l: string;
  }> | null;
  productTag?: string | null;
  className?: string;
};

function ProductMedia({ mediaPath, alt, additionalImages, productTag, className }: MediaProps) {
  const [displayedIndex, setDisplayedIndex] = useState(0);
  const [showImageModal, setShowImageModal] = useState(false);

  const openImageModalIfNotMobile = () => {
    if (window.innerWidth < 1200) setShowImageModal(false);
    else setShowImageModal(true);
  };

  const imageArray = useMemo(() => {
    if (additionalImages && Object.keys(additionalImages).length > 0) {
      return Object.keys(additionalImages).map((key) => ({
        key: parseInt(key),
        image: additionalImages[parseInt(key)],
      }));
    } else {
      return [];
    }
  }, [additionalImages]);

  return (
    <>
      <aside className={`${style.ProductMedia} ${className ?? ""}`}>
        <section className={style.thumbnailContainer}>
          {imageArray &&
            imageArray.length > 0 &&
            imageArray.map(({ key, image }) => {
              return (
                <div key={key}>
                  <ProductImage
                    className={`${style.thumbnail} ${key === displayedIndex ? style.selected : ""}`}
                    src={image.s ? fixImageURI(image.s) : ""}
                    alt={alt ? alt : ""}
                    width={44}
                    height={44}
                    onClick={() => setDisplayedIndex(key)}
                  />
                </div>
              );
            })}
        </section>
        <figure className={style.productImageFrame} title={alt}>
          <div className={style.productImage}>
            {productTag && <div className={style.productTag}>{productTag}</div>}
            {additionalImages && imageArray.length > 0 ? (
              imageArray.map(({ key, image }) => {
                return (
                  <ProductImage
                    key={"image-" + key}
                    className={`${style.image} ${key === displayedIndex ? "" : style.hidden}`}
                    src={image.l ? fixImageURI(image.l) : ""}
                    alt={alt ? alt : ""}
                    width={184}
                    height={184}
                    fallbackFillsContainer
                    onClick={() => openImageModalIfNotMobile()}
                  />
                );
              })
            ) : (
              <ProductImage
                className={style.image}
                src={mediaPath ? fixImageURI(mediaPath) : ""}
                alt={alt ? alt : ""}
                width={184}
                height={184}
                fallbackFillsContainer
                onClick={() => openImageModalIfNotMobile()}
              />
            )}
          </div>
        </figure>
      </aside>
      <Modal show={showImageModal} onHide={() => setShowImageModal(false)} ariaLabel={alt ? alt : "Product image"}>
        <figure className={style.zoomFigure} title={alt}>
          {additionalImages && imageArray.length > 0 ? (
            imageArray.map(({ key, image }) => {
              return (
                <ProductImage
                  key={"image-" + key}
                  className={`${style.zoomImage} ${key === displayedIndex ? "" : style.hidden}`}
                  src={image.l ? fixImageURI(image.l) : ""}
                  width={184}
                  height={184}
                  alt={alt ? alt : ""}
                  fallbackFillsContainer
                />
              );
            })
          ) : (
            <ProductImage
              className={style.zoomImage}
              src={mediaPath ? fixImageURI(mediaPath) : ""}
              width={184}
              height={184}
              alt={alt ? alt : ""}
              fallbackFillsContainer
            />
          )}
        </figure>
      </Modal>
    </>
  );
}

export default ProductMedia;
